import { OrderEntity } from 'src/firebase/db/Orders';
import { BakedBreadEntity } from 'src/firebase/db/BakedBreads';

/**
 * 注文が予約商品かチェック（予約商品の仕様次第で要回収...）
 */
export const isReservation = (order: OrderEntity, bakedBreads: BakedBreadEntity[]) => {
  const { items } = order;

  // 商品の種類が2つ以上ある場合は予約商品ではない
  if (items.length > 1) {
    return false;
  }
  const item = items[0];
  if (!item) {
    return false;
  }
  const {
    order_bread: { bread_id },
  } = item;
  return bakedBreads.some(({ id, is_reservation }) => id === bread_id && is_reservation);
};
